import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'otable_user_status';

export const USER_STATUSES = [
  { key: 'online',  label: 'Online',  color: '#4caf50', desc: 'Available for chat'  },
  { key: 'busy',    label: 'Busy',    color: '#c52419', desc: 'Do not disturb'       },
  { key: 'idle',    label: 'Idle',    color: '#ff9800', desc: 'Away from keyboard'   },
  { key: 'offline', label: 'Offline', color: '#9e9e9e', desc: 'Appear offline'       },
];

export function getStatusMeta(key) {
  return USER_STATUSES.find(s => s.key === key) || USER_STATUSES[0];
}

const UserStatusContext = createContext({ status: 'online', setStatus: () => {} });

export function UserStatusProvider({ children }) {
  const [status, setStatusState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || 'online'
  );

  const setStatus = useCallback((key) => {
    localStorage.setItem(STORAGE_KEY, key);
    setStatusState(key);
  }, []);

  return (
    <UserStatusContext.Provider value={{ status, setStatus }}>
      {children}
    </UserStatusContext.Provider>
  );
}

export function useUserStatus() {
  return useContext(UserStatusContext);
}
